import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
//  Import SVG icons
import { ReactComponent as SunIcon } from '../../assets/icons/bulb.svg';
import { ReactComponent as MoonIcon } from '../../assets/icons/bulb-on.svg';

const PageContainer = ({ children, title, subtitle, actions }) => {
  const { theme, toggleTheme } = useTheme();

  const containerStyle = {
    padding: '24px',
    maxWidth: '1600px',
    margin: '0 auto',
    minHeight: '100vh'
  };

  const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '32px',
    flexWrap: 'wrap',
    gap: '16px'
  };

  const titleSectionStyle = {
    flex: 1,
    minWidth: '200px'
  };

  const titleStyle = {
    fontSize: '32px',
    fontWeight: '700',
    color: 'var(--text-primary)',
    marginBottom: '8px'
  };

  const subtitleStyle = {
    fontSize: '14px',
    color: 'var(--text-secondary)'
  };

  const actionsSectionStyle = {
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    flexWrap: 'wrap'
  };

  const themeButtonStyle = {
    padding: '0',
    background: 'var(--surface)',
    border: '1px solid var(--border)',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px'
  };

  const iconStyle = {
    width: '20px',
    height: '20px',
    color: 'var(--text-primary)',
    transition: 'transform 0.3s ease'
  };

  return (
    <div style={containerStyle}>
      <div style={headerStyle}>
        <div style={titleSectionStyle}>
          {title && <h1 style={titleStyle}>{title}</h1>}
          {subtitle && <p style={subtitleStyle}>{subtitle}</p>}
        </div>
        <div style={actionsSectionStyle}>
          {actions}
          <button
            style={themeButtonStyle}
            onClick={toggleTheme}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.1)';
              e.currentTarget.style.background = 'var(--surface-light)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.background = 'var(--surface)';
            }}
          >
            {/*  Use SVG components instead of emojis */}
            {theme === 'dark' ? (
              <SunIcon style={iconStyle} />
            ) : (
              <MoonIcon style={iconStyle} />
            )}
          </button>
        </div>
      </div>
      {children}
    </div>
  );
};

export default PageContainer;